import { useApiInspectionsV1CompaniesRetrieve } from 'api';
import { useTranslation } from 'i18n';
import { Box, Grid, Typography } from 'ui';

export const CompanyInspectorsList = ({ companyId }: { companyId: number }) => {
  const { t } = useTranslation('orders');
  const { data } = useApiInspectionsV1CompaniesRetrieve(companyId);

  if (!data || !data.inspectors.length) {
    return <Typography variant="subtitle2">{t('inspectionCompany.list.noInspectors')}</Typography>;
  }

  return (
    <>
      {data.inspectors.map((inspector) => (
        <Box
          key={`${inspector.id}-${inspector.name}`}
          sx={(theme) => {
            return {
              border: `1px solid ${theme.palette.border.main}`,
              borderRadius: theme.spacing(1),
              mb: 1,
              padding: theme.spacing(1),
            };
          }}
        >
          <Grid container spacing={2}>
            <Grid size={8}>
              <Typography variant="subtitle1">{inspector.name}</Typography>
              <Typography variant="subtitle2">{inspector.email}</Typography>
              <Typography variant="subtitle2">{inspector.phone_number}</Typography>
            </Grid>
            <Grid sx={{ alignItems: 'center', display: 'flex' }} size={4}>
              <Typography variant="subtitle2">
                {inspector.is_active ? t('inspectionCompany.status.active') : t('inspectionCompany.status.inactive')}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
};
